module.exports = __webpack_public_path__ + "asset/image-Balance-scale-92413b9769acaa69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Balance-scale.svg
// module id = Qyae
// module chunks = 0